<template>
  <LevellingPageShell title="Job Mapping" icon="mdi-file-tree-outline">
    <LevellingReports v-bind="$attrs" v-on="$listeners" />
  </LevellingPageShell>
</template>

<script>
// Job Mapping ToC page (renamed Job Architecture) — page head + centred content
// around the levelling reports (LevellingReports: Job Framework / Career Ladder
// / Heat Map). $attrs/$listeners forward props + emits to App.vue's router-view.
import LevellingPageShell from '@/components/levelling/LevellingPageShell.vue';
import LevellingReports from '@/components/levelling/LevellingReports.vue';

export default {
  name: 'JobMappingPage',
  components: { LevellingPageShell, LevellingReports },
  inheritAttrs: false,
};
</script>
